<template>
  <div
    v-if="$hasRole(['hr'])"
    class="dashboard-error-notif p-2"
  >
    <b-alert
      variant="danger"
      class="m-0"
      :show="!isCompaniesAssigned"
    >
      <font-awesome-icon
        icon="exclamation-triangle"
        class="danger-icon m-auto"
      />
      <span class="ml-2">{{ $t('pages.dashboards.hr.no-companies-warning') }}</span>
    </b-alert>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isCompaniesAssigned: true
    }
  },
  mounted() {
    if(this.$hasRole(['hr'])) {
      this.checkCompaniesAssigned();
    }
  },
  methods: {
    checkCompaniesAssigned() {
      this.axios.get('/hr/is-companies-assigned')
        .then( response => {
          this.isCompaniesAssigned = response.data;
        })
        .catch();
    }
  }
}
</script>


<style lang="scss" scoped>
  .dashboard-error-notif {
    background: white;
  }
</style>
